import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "./Navbar";
import "../styles/InformesPendientes.css";

// Normalizar API_URL (remover barra final si existe)
const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4004').replace(/\/$/, '');

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
};

const InformesPendientes = () => {
  const [informes, setInformes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showDevolverModal, setShowDevolverModal] = useState(false);
  const [selectedInforme, setSelectedInforme] = useState(null);
  const [observacion, setObservacion] = useState("");
  const [showDesestimarModal, setShowDesestimarModal] = useState(false);
  const [observacionDesestimar, setObservacionDesestimar] = useState("");

  useEffect(() => {
    const fetchInformes = async () => {
      try {
        const { data } = await axios.get(`${API_URL}/api/informes`, {
          headers: getAuthHeaders()
        });
        setInformes(data);
      } catch (error) {
        console.error("❌ Error al obtener informes:", error);
      }
    };
    fetchInformes();
  }, []);

  const aprobarInforme = async (id) => {
    try {
      await axios.put(
        `${API_URL}/api/informes/${id}/confirmar`,
        {
          Estado: "Confirmado",
          Observacion: "Aprobado por inspector encargado",
        },
        {
          headers: getAuthHeaders()
        }
      );
      setInformes((prev) => prev.filter((inf) => inf.id !== id));
    } catch (error) {
      console.error("❌ Error al aprobar informe:", error);
    }
  };

  const desestimarInforme = async (id, observacion) => {
    try {
      await axios.put(`${API_URL}/api/informes/${id}/confirmar`, {
        Estado: "Desestimado",
        Observacion: observacion,
      }, {
        headers: getAuthHeaders()
      });
      setInformes((prev) => prev.filter((inf) => inf.id !== id));
      setShowDesestimarModal(false);
    } catch (error) {
      console.error("❌ Error al desestimar informe:", error);
    }
  };


  const devolverInforme = async (id, observacion) => {
    try {
      await axios.put(
        `${API_URL}/api/informes/${id}/devolver`,
        { MotivoDevolucion: observacion },
        {
          headers: getAuthHeaders()
        }
      );
      setInformes((prev) => prev.filter((inf) => inf.id !== id));
      setShowDevolverModal(false);
      setObservacion("");
    } catch (error) {
      console.error("❌ Error al devolver informe:", error);
    }
  };


  const abrirModalDesestimar = (informe) => {
    setSelectedInforme(informe);
    setObservacionDesestimar("");
    setShowDesestimarModal(true);
  };

  const verDetalles = (informe) => {
    setSelectedInforme(informe);
    setShowModal(true);
  };

  const abrirModalDevolver = (informe) => {
    setSelectedInforme(informe);
    setObservacion("");
    setShowDevolverModal(true);
  };

  

  return (
    <div className="informes-container">
      <Navbar />
      <h2 className="title">Informes Generados</h2>

      <div className="table-wrapper">
        <table className="informes-table">
          <thead>
            <tr>
              <th>N° Informe</th>
              <th>Inspector</th>
              <th>Motivo</th>
              <th>Fecha</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {informes.map((inf) => (
              <tr key={inf.id} className="row-hover">
                <td>{inf.NroInforme}</td>
                <td>{inf.RealizadoPor}</td>
                <td>{inf.Motivo}</td>
                <td>{inf.FechaRealizado.split("T")[0]}</td>
                <td className="acciones">
                  <button
                    className="icon-btn aprobar"
                    onClick={() => aprobarInforme(inf.id)}
                    title="Aprobar informe"
                  >
                    ✔
                  </button>
                  <button
                    className="icon-btn desestimar"
                    onClick={() => abrirModalDesestimar(inf)}
                    title="Desestimar informe"
                  >
                    ✖
                  </button>
                  <button
                    className="icon-btn detalles"
                    onClick={() => verDetalles(inf)}
                    title="Ver detalles del informe"
                  >
                    👁
                  </button>
                  <button
                    className="icon-btn devolver"
                    onClick={() => abrirModalDevolver(inf)}
                    title="Devolver informe para edición"
                  >
                    ↩
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal de detalles */}
      {showModal && selectedInforme && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3 className="modal-title">
              Detalles del Informe #{selectedInforme.NroInforme}
            </h3>
            <div className="modal-body">
              <p>
                <strong>Inspector (legajo):</strong> {selectedInforme.RealizadoPor}
              </p>
              <p>
                <strong>Empleado:</strong> {selectedInforme.NombreEmp} (Legajo{" "}
                {selectedInforme.LegajoEmp})
              </p>
              <p>
                <strong>Motivo:</strong> {selectedInforme.Motivo}
              </p>
              <p>
                <strong>Detalle:</strong> {selectedInforme.MotivoDetalle}
              </p>
              <p>
                <strong>Fecha:</strong>{" "}
                {selectedInforme.FechaRealizado.split("T")[0]}
              </p>
              <p>
                <strong>Hora:</strong> {selectedInforme.Hora}
              </p>
              <p>
                <strong>Estado:</strong> {selectedInforme.Estado}
              </p>
              {selectedInforme.Observacion && (
                <p>
                  <strong>Observación:</strong> {selectedInforme.Observacion}
                </p>
              )}
              {selectedInforme.SancionPropuesta && (
                <p>
                  <strong>Sanción propuesta:</strong>{" "}
                  {selectedInforme.SancionPropuesta}
                </p>
              )}
              {selectedInforme.SancionAplicada && (
                <p>
                  <strong>Sanción aplicada:</strong>{" "}
                  {selectedInforme.SancionAplicada}
                </p>
              )}
            </div>
            <div className="modal-footer">
              <button onClick={() => setShowModal(false)} className="close-btn">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de devolución con observación */}
      {showDevolverModal && selectedInforme && (
        <div className="modal-overlay" onClick={() => setShowDevolverModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3 className="modal-title">Devolver informe #{selectedInforme.NroInforme}</h3>
            <textarea
              value={observacion}
              onChange={(e) => setObservacion(e.target.value)}
              rows={4}
              className="modal-textarea"
              placeholder="Escriba la observación para el inspector..."
            />
            <div className="modal-footer">
              <button
                onClick={() => setShowDevolverModal(false)}
                className="btn btn-ghost"
              >
                Cancelar
              </button>
              <button
                onClick={() => devolverInforme(selectedInforme.id, observacion)}
                className="btn btn-primary"
                disabled={!observacion.trim()} // 👈 evita enviar vacío
              >
                Devolver
              </button>
            </div>
          </div>
        </div>
      )}

      {showDesestimarModal && selectedInforme && (
      <div className="modal-overlay" onClick={() => setShowDesestimarModal(false)}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <h3>Desestimar informe #{selectedInforme.NroInforme}</h3>
          <textarea
            value={observacionDesestimar}
            onChange={(e) => setObservacionDesestimar(e.target.value)}
            rows={4}
            style={{ width: "100%" }}
            placeholder="Escriba la observación para el inspector..."
          />
          <div className="modal-footer">
            <button
              onClick={() => setShowDesestimarModal(false)}
              className="btn btn-ghost"
            >
              Cancelar
            </button>
            <button
              onClick={() => desestimarInforme(selectedInforme.id, observacionDesestimar)}
              className="btn btn-primary"
              disabled={!observacionDesestimar.trim()}
            >
              Desestimar
            </button>
          </div>
        </div>
      </div>
    )}
    </div>
  );
};

export default InformesPendientes;
